export default __webpack_public_path__ + "static/media/02TheHealingForce60s.49b7f7d1.mp3";